export default __webpack_public_path__ + "images/16d38232edecfd0a2b39b5dbb583734b.svg";